import {Fade} from "react-awesome-reveal";
import React from "react";

function ChangeFade (props) {
            return (
                <Fade direction={props.direction}>
                    {props.children}
                </Fade>
            )
}

export default ChangeFade
